import sharingImg from '@/assets/images/share-fill.svg';
import volumeOffImg from '@/assets/images/volumeMute.svg';
import closeButtonImg from '@/assets/images/closeButton.svg';

// 05/03-削除ではなく一旦非表示で対応
// import pauseImg from '@/assets/images/pause.png';

export const desktopMenuArea = () => {
  const iconsDiv = document.createElement('div');
  iconsDiv.className = 'storeeel-menu-area-icons';
  iconsDiv.style.display = 'flex';
  iconsDiv.style.alignItems = 'center';
  iconsDiv.style.justifyContent = 'flex-end'; // 右寄せにする
  iconsDiv.style.padding = '11px';
  iconsDiv.style.gap = '15px'; // 要素間の間隔
  iconsDiv.style.marginTop = '10px';
  iconsDiv.style.position = 'fixed';
  iconsDiv.style.top = '0';
  iconsDiv.style.right = '0';
  iconsDiv.style.width = 'fit-content';
  iconsDiv.style.zIndex = '100';

  // 共有アイコンの作成
  const sharingIcon = document.createElement('img');
  sharingIcon.src = sharingImg;
  sharingIcon.alt = 'sharing';
  sharingIcon.style.width = '26px';
  sharingIcon.style.height = '26px';
  sharingIcon.style.aspectRatio = '1 / 1';
  sharingIcon.style.cursor = 'pointer';
  sharingIcon.id = 'sharing-desktop';

  // 音量オフアイコンの作成
  const volumeIcon = document.createElement('img');
  volumeIcon.src = volumeOffImg;
  volumeIcon.alt = 'volume';
  volumeIcon.style.width = '38px';
  volumeIcon.style.height = '38px';
  volumeIcon.style.aspectRatio = '1 / 1';
  volumeIcon.style.cursor = 'pointer';
  volumeIcon.className = 'storeeel-volume';
  volumeIcon.id = 'volume-desktop';
  volumeIcon.setAttribute('data-muted', 'true');

  // 閉じるボタンの作成
  const closeButton = document.createElement('img');
  closeButton.src = closeButtonImg;
  closeButton.className = 'cross-close-button-parent';
  closeButton.style.display = 'inline-block';
  closeButton.style.verticalAlign = 'middle';
  closeButton.style.position = 'relative'; // position: relativeに変更
  closeButton.style.cursor = 'pointer';
  closeButton.style.width = '33px';
  closeButton.style.height = '33px';
  closeButton.style.aspectRatio = '1 / 1';

    // 05/03-削除ではなく一旦非表示で対応
  // 一時停止ボタンの作成
  // const pauseButton = document.createElement('img');
  // pauseButton.src = pauseImg;
  // pauseButton.alt = 'pause';
  // pauseButton.style.width = '4%';
  // pauseButton.className = 'storeeel-video-control';
  // pauseButton.id = 'pause-desktop';
  // pauseButton.style.cursor = 'pointer';

  // アイコンをアイコンコンテナに追加
  iconsDiv.appendChild(volumeIcon);
  iconsDiv.appendChild(sharingIcon);

  // 05/03-削除ではなく一旦非表示で対応
  // iconsDiv.appendChild(pauseButton);
  iconsDiv.appendChild(closeButton);

  const htmlString = `
    ${iconsDiv.outerHTML}
  `;

  return htmlString;
}
